import { inject, signal } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { AlertMessageService } from "../alert-msg/message.service";
import { catchError, of } from "rxjs";

export const examQuestionsResolver: ResolveFn<any> = (route, state) => {
  const sub_slug = signal<string>(route.paramMap.get("sub") ?? "");
  const curriclum_slug = signal<string>(route.paramMap.get("cur") ?? "");
  const _alertMessageService = inject(AlertMessageService);
  const _httpClient = inject(HttpClient);
  const baseUrl = environment.apiUrl;

  return _httpClient.get(`${baseUrl}api/website/subjects/${sub_slug()}/questions?curriclum_slug=${curriclum_slug()}`).pipe(
    catchError((err) => {
      _alertMessageService.addMsg(err?.error?.msg || "Error loading Curriclum data");
      return of(undefined);
    }),
  );;
}
